
angular.module("swapick")
.factory('AffidabilityBands', AffidabilityBands);

function AffidabilityBands() {
  const svc = {};

  const bands = [
    { from: 0, to: 0, rank: 0, label: 'Utente inattivo (o Utente nuovo)' },
    { from: 1, to: 69, rank: 1, label: 'Inaffidabile (o Utente poco attivo)' },
    { from: 70, to: 79, rank: 2, label: 'Poco affidabile' },
    { from: 80, to: 89, rank: 3, label: 'Non sempre affidabile'  },
    { from: 90, to: 95, rank: 4, label: 'Abbastanza affidabile' },
    { from: 96, to: 100, rank: 5, label: 'Affidabile' },
  ];

  svc.getBands = () => bands;

  svc.getBandByPercent = (percent) => (
    _.find(bands, ({ from, to }) => percent >= from && percent <= to)
  );

  return svc;
}



// WEBPACK FOOTER //
// ./src/services/affidability-bands-service.js